import { render, staticRenderFns } from "./chitchat.vue?vue&type=template&id=6cfe3020&scoped=true"
import script from "./chitchat.vue?vue&type=script&lang=js"
export * from "./chitchat.vue?vue&type=script&lang=js"
import style0 from "./chitchat.vue?vue&type=style&index=0&id=6cfe3020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe3020",
  null
  
)

export default component.exports